<template>
    <div class="useful-services__container">
        <div class="useful-services">
            <h2 class="useful-services__title h2">Полезные сервисы</h2>
            <div class="useful-services__card">
                <UsefulCard
                    v-for="usefulCard in usefulCards"
                    :key="usefulCard.id"
                    :slide-img="usefulCard.slideImg"
                    :slide-title="usefulCard.slideTitle"
                    :slide-value="usefulCard.slideValue"
                    :slide-link="usefulCard.slideLink"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import UsefulCard from '@/components/Sliders/OfferSlider/UsefulCard.vue';

export default defineComponent({
    name: 'ServicesComponent',
    components: {
        UsefulCard,
    },
    props: {
        usefulCards: {
            type: Array,
            default: () => ([]),
        },
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/index/services';
</style>
